/* --- COMMUNICATIONS MODULE --- */
export const SET_COMMUNICATIONS_LIST = "SET_COMMUNICATIONS_LIST";
export const SET_COMMUNICATION = "SET_COMMUNICATION";
export const SET_SELECTED_COMMUNICATION = "SET_SELECTED_COMMUNICATION";
export const SET_COMMUNICATIONS_LOADING = "SET_COMMUNICATIONS_LOADING";

